import { z } from 'zod'

import { PhoneSchema } from '@/ducks/common.schema'

export const BankSchema = z.object({
  phone: PhoneSchema,
  name: z.string(),
  account_holder: z.string(),
  account_number: z.string(),
  country_code: z.string(),
  logo: z.string(),
  example: z.string()
})

const ApiFetchBankInformationSchema = z.object({
  banks: z.array(BankSchema)
})

export { ApiFetchBankInformationSchema }
